const DIGITS = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

/** A figure whose digits roll into place like a slot reel. Each digit is a column of 0 to 9
 * moved to its place over an invisible copy of itself that holds the width; anything else (a sign,
 * a comma) is set as it is. Keyed from the right, so a figure that grows a digit keeps its reels. */
export function Roll({ text, className }: { text: string; className?: string }) {
  const chars = [...text];
  return (
    <span className={`roll ${className ?? ""}`} aria-label={text}>
      {chars.map((char, index) => {
        const key = chars.length - index;
        if (!/\d/.test(char)) {
          return (
            <span key={`s${key}`} className="roll-sym" aria-hidden>
              {char}
            </span>
          );
        }
        return (
          <span key={`d${key}`} className="roll-reel" aria-hidden>
            <span className="roll-ghost">{char}</span>
            <span className="roll-strip" style={{ transform: `translateY(-${Number(char) * 10}%)` }}>
              {DIGITS.map((digit) => (
                <span key={digit}>{digit}</span>
              ))}
            </span>
          </span>
        );
      })}
    </span>
  );
}
